export const qaPrefix = 'reqf-qbooks-vendor-creation-popup';
